module.exports = {
  CAR_ALERTS: 'car-alerts',
  CRASH_REPORTS: 'crash-reports',
  EMOBILITY_ADVISOR: 'emobility-advisor',
  PHEV_REPORT: 'phev-report',
  PUSH_DATA: 'push-data',
  PUSH_ECO_DRIVING: 'push-eco-driving',
  TRIPS: 'trips',
  SVT: 'svt',
};
